import { Card, Row } from 'antd';
import React from 'react'
import Heading from '../../../component/common/Heading';
import CRUDComponent from '../../../component/common/CRUD-Component';
import CONSTANTS from '../../../util/constant/CONSTANTS';
import { useNavigate, useParams } from 'react-router-dom';
import BackButton from '../../../component/common/Back-Button';

const BenchMarkActivity = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    return (
        <>

            <div>
                <Card className="my-5">
                    <BackButton onClick={() => navigate(-1)} />
                    <Heading>BenchMark Activity</Heading>
                    <Row>
                        <CRUDComponent
                            GET={{
                                API: CONSTANTS.API.BenchmarkActivity.getAll,
                                extraQuery: {
                                    benchmarkId: id
                                },
                                DataModifier: (res, API, Setrefresh) => {
                                    return res?.map(data => {
                                        return {
                                            ...data,
                                            no: `BA${data?.id.toString().padStart(7, "0")}`,




                                        }
                                    });
                                },
                                column: CONSTANTS.TABLE.BENCHMARK_ACTIVITY,
                            }}
                            // isSearch
                            UPDATE={{
                                API: CONSTANTS.API.BenchmarkActivity.update,
                                message: "Edit Benchmark Activity successfully",
                                modaltitle: "Edit Benchmark",
                                modalFields: CONSTANTS.FORM_FIELD.BENCHMARK_ACTIVITY_MODAL,
                                payloadModifier: (res) => {
                                    return {
                                        benchmarkId: id,
                                        age: `${res?.startAge}-${res?.endAge}`,
                                        walkTime: res?.walkTime,
                                        playTime: res?.playTime,
                                        sleepTime: res?.sleepTime,
                                        restTime: res?.restTime,
                                    }
                                },
                            }}
                            CREATE={{
                                API: CONSTANTS.API.BenchmarkActivity.add,
                                message: "Created Benchmark Activity successfully",
                                modaltitle: "Add Benchmark",
                                modalFields: CONSTANTS.FORM_FIELD.BENCHMARK_ACTIVITY_MODAL,
                                payloadModifier: (res) => {
                                    return {
                                        benchmarkId: id,
                                        age: `${res?.startAge}-${res?.endAge}`,
                                        walkTime: res?.walkTime,
                                        playTime: res?.playTime,
                                        sleepTime: res?.sleepTime,
                                        restTime: res?.restTime,
                                    }
                                },
                            }}
                            DELETE={{
                                API: CONSTANTS.API.BenchmarkActivity.delete,
                                message: "Deleted Successfully",
                            }}
                        />
                    </Row>
                </Card>

            </div>
        </>
    )
}

export default BenchMarkActivity